import * as React from 'react';
import useDraft from '../hooks/useDraft';
import { useEditor } from '../hooks/useEditor';
import CopyIcon from '../icons/CopyIcon';
import SaveDialog from './SaveDialog';
import TemplateChanger from './TemplateChanger';

export default function EditorKiteSettings() {
    const { copy } = useEditor();
    const { draft } = useDraft();

    return (
        <div className="editor__kite-settings">
            <TemplateChanger />
            <SaveDialog key={draft.id} />
            <button onClick={copy}>
                <CopyIcon />
                copy
            </button>
        </div>
    );
}
